import React from "react";

function DownloadPDF3() {
    return(
        <div style={{ backgroundColor: '#3b82f6' }} className="text-white font-medium rounded-lg text-sm px-5 py-2.5 w-40 mt-3 flex justify-center mx-auto" >
            {/* <a href="goldmansachs cv.pdf" download="GoldmanSachs one page Template.pdf">Download</a> */}
            <a href="GoldmanSachs one page Template.pdf" target="_blank" rel="noopener noreferrer">Download</a>
        </div>
    )
}
export default DownloadPDF3